export default "__VITE_ASSET__mOtXV5sz__"